import React from 'react';
import { Avatar } from '@material-ui/core';
import { useStyles } from './styles';
import Button from '@material-ui/core/Button';

const DivStatusWaiting = ({ user, openDetails, exchange }) => {
  const classes = useStyles();

  return (
    <div>
      <Button
        type="button"
        onClick={() => {
          openDetails(exchange, user);
        }}
        style={{
          padding: 0,
        }}
      >
        <Avatar className={classes.avatarWaiting} src={user?.image} />
      </Button>
    </div>
  );
};

export default DivStatusWaiting;
